<template>
  <div class="mb-publish-block">
    <div class="publish-nav">
      <a-icon type="left" @click="back" />
      <span>{{ $t("moduleTitles.pcpublish") }}</span>
      <div></div>
    </div>
    <!-- 發佈成功 -->
    <!-- <div v-if="userInfo.expire_status" class="publish-success-box">
      <TopUpTip></TopUpTip>
    </div> -->
    <!-- 發佈全景內容 -->
    <div >
      <div class="mb-publish-panorama">
        <div class="drag-upload">
          <DragUploader
            uptype="sourceimg"
            ref="uploader"
            @uploadFail="uploadFail"
            @startUploadImage="startUploadImage"
            @updateImagefiles="updateImageList"
          ></DragUploader>
        </div>
        <p style="margin-top: 10px">
          <a-button
            type="primary"
            href="javascript:void(0);"
            @click="addImage"
            >{{ $t("publish.addMer") }}</a-button
          >
        </p>
        <p style="margin-top: 10px">
          <a-button type="primary" @click="addPanoramic">{{
            $t("publish.addPanoramic")
          }}</a-button>
        </p> 
      </div>

      <div class="mb-publish-info">
        <van-field
          v-model="info.name"
          rows="1"
          :autosize="true"
          :label="$t('publish.workName.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.workName.placeholder')"
          show-word-limit
          input-align="right"
        />
        <van-field
          v-model="info.customer_name"
          rows="1"
          :autosize="true"
          :label="$t('publish.customerName.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.customerName.placeholder')"
          show-word-limit
          input-align="right"
        />
        <van-field
          v-model="info.customer_phone"
          rows="1"
          :autosize="true"
          :label="$t('publish.customerTel.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.customerTel.placeholder')"
          show-word-limit
          input-align="right"
        />
        <van-cell
          :title="$t('publish.workCategory.label')"
          is-link
          :value="info.cate_name"
          @click="showCatePicker"
        />
        <van-cell
          :title="$t('publish.industry.label')"
          is-link
          :value="info.industry_name"
          @click="isShowIndustryPicker = true"
        />
        <!-- <van-cell
          title="作品地區"
          is-link
          :value="info.region_name"
          @click="isShowRegionPicker = true"
        /> -->
        <region @updateRegin="updateRegin"></region>
        <van-field
          v-model="info.detail_address"
          rows="1"
          :autosize="true"
          :label="$t('publish.address.label')"
          type="textarea"
          max-length="50"
          :placeholder="$t('publish.address.placeholder')"
          show-word-limit
          input-align="right"
        />
        <van-cell
          :title="$t('publish.savePath.label')"
          is-link
          :value="info.dir_name"
          @click="treeVisible = true"
        />
        <van-cell :title="$t('publish.isPublic')">
          <span slot="default">
            <van-radio-group v-model="info.is_public" direction="horizontal">
              <van-radio :name="1">{{ $t("publish.public") }}</van-radio>
              <van-radio :name="0">{{ $t("publish.pravite") }}</van-radio>
            </van-radio-group>
          </span>
        </van-cell>
        
        <van-cell title="顯示浮水印">
          <span slot="default">
            <van-radio-group v-model="info.is_water" direction="horizontal">
              <van-radio :name="1">是</van-radio>
              <van-radio :name="0">否</van-radio>
            </van-radio-group>
          </span>
        </van-cell>

        <div class="info-tag-block">
          <p>
            <span class="info-tag-title">{{
              $t("publish.workTag.label")
            }}</span>
          </p>
          <div class="info-tag-list">
            <template v-for="item in tagList">
              <a-tag
                :color="item.isSelected ? 'red' : ''"
                class="tag-btns"
                :closable="item.uid === userInfo.id"
                @close="deleteTag(item, $event)"
                :key="item.id"
                @click="selectTag(item.id)"
                >{{ item.name }}</a-tag
              >
            </template>
            <a-tag class="tag-btns" @click="isShowAddTagModel = true"
              >+{{ $t("publish.tagAdd") }}</a-tag
            >
          </div>
        </div>
        
        <div class="publich-btn">
          <a-button
            class="btns"
            type="danger"
            block
            shape="round"
            :disabled="isUploading"
            @click="publish"
            >{{ $t("publish.publish") }}</a-button
          >
        </div>

        <HMaterialModal
          :visible="materialVisible"
          ref="material"
          :type="2"
          @close="materialVisible = false"
          @handleConfirm="materialConfirm"
        ></HMaterialModal>
        <HMaterialModal
          :visible="panoramicVisible"
          ref="panoramic"
          :type="1"
          @close="panoramicVisible = false"
          @handleConfirm="materialConfirm"
        ></HMaterialModal>
        <!-- 作品分類picker -->
        <van-popup
          v-model="isShowCatePicker"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <div class="van-picker__toolbar">
            <button
              type="button"
              class="van-picker__cancel"
              @click="isShowCatePicker = false"
            >
              {{ $t("actionTitles.cancel") }}
            </button>
            <div class="van-ellipsis van-picker__title">
              {{ $t("descriptions.selectWorkCate") }}
            </div>
            <button
              type="button"
              class="van-picker__confirm"
              @click="confirmCate"
            >
              {{ $t("actionTitles.ascertain") }}
            </button>
          </div>
          <a-tree
            style="width: 100%; height: 264px"
            :replaceFields="{
              children: 'children',
              title: 'name',
              key: 'id',
              value: 'id',
            }"
            :tree-data="cateTree"
            :defaultSelectedKeys="[info.cate]"
            default-expand-all
            @select="onSelectCate"
          ></a-tree>
        </van-popup>
        <!-- 作品行業picker -->
        <van-popup
          v-model="isShowIndustryPicker"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <van-picker
            show-toolbar
            :columns="IndustryList"
            :title="$t('descriptions.selectWorkIndustry')"
            @confirm="confirmIndustry"
            @cancel="isShowIndustryPicker = false"
          />
        </van-popup>
        <van-dialog
          v-model="isShowAddTagModel"
          :title="$t('publish.addNewTag.label')"
          show-cancel-button
          @confirm="confirmAddTag"
          @closed="tagModelclosed"
          confirm-button-color="#1989fa"
        >
          <div style="padding: 5px; padding-left: 10%">
            <van-field
              v-model="tagForm.name"
              rows="1"
              :autosize="true"
              type="textarea"
              :placeholder="$t('publish.addNewTag.placeholder')"
            />
          </div>
        </van-dialog>
        <!-- 目錄picker -->
        <van-popup
          v-model="treeVisible"
          position="bottom"
          :safe-area-inset-bottom="true"
        >
          <div class="van-picker__toolbar">
            <button
              type="button"
              class="van-picker__cancel"
              @click="treeVisible = false"
            >
              {{ $t("actionTitles.cancel") }}
            </button>
            <div class="van-ellipsis van-picker__title">
              {{ $t("descriptions.selectPath") }}
            </div>
            <button type="button" class="van-picker__confirm" @click="confirm">
              {{ $t("actionTitles.ascertain") }}
            </button>
          </div>
          <a-directory-tree
            style="width: 100%; height: 264px"
            :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
            :load-data="onLoadData"
            :tree-data="treeData"
            :selectedKeys="selectedKeys"
            @select="onSelect"
          />
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { v4 as uuidv4 } from "uuid";
import DragUploader from "@/components/DragUploader";
import HMaterialModal from "@/components/HMaterialModal";
import TopUpTip from "@/components/TopUpTip";
import Region from "@/components/region";
import {
  getIndustry,
  publishVRImg,
  addTag,
  getTag,
  getRegoin,
  deleteTag,
  regionTree,
} from "@/api/publish";
import { getTreeDir } from "@/api/work";
import HRegionSelect from "@/components/HRegionSelect";
import { getTree as getCateTree } from "@/api/cate";
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  Cell,
  CellGroup,
  Field,
  Popup,
  Picker,
  RadioGroup,
  Radio,
  Dialog,
} from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Dialog);

export default {
  components: {
    HRegionSelect,
    HMaterialModal,
    DragUploader,
    Cell,
    CellGroup,
    Field,
    Popup,
    Picker,
    TopUpTip,
    Region,
  },

  data() {
    return {
      info: {
        name: "",
        customer_name: "",
        customer_phone: "",
        detail_address: "",
        dir_id: 0,
        dir_name: this.$t("moduleTitles.root"),
        cate: null,
        cate_name: "",
        industry: null,
        industry_name: "",
        is_public: 1,
        is_water: 0,
        region: null,
        region_name: "",
        pic_tags: [],
        imgs: [],
        mimgs: [],
        panoVideos: [],
      },
      isShowCatePicker: false,
      cateOriginalData: {},
      // cateList: [],
      cateTree: [],
      cateStore: [],
      isShowIndustryPicker: false,
      IndustryList: [],
      IndustryOriginalData: [],
      isShowAddTagModel: false,
      tagForm: {
        type: 0,
        name: "",
      },
      tagList: [],
      fileList: [],
      materialVisible: false,
      treeVisible: false,
      selectedKeys: [],
      selectedName: "",
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      loadedKeys: [],
      isSuccess: false,
      isUploading: false,

      isShowRegionPicker: false,
      regionList: [
        {
          values: [],
          defaultIndex: 0,
        },
        {
          values: [""],
          defaultIndex: 0,
        },
        {
          values: [""],
          defaultIndex: 0,
        },
      ],
      currentRegType: 1,
      regionProvice: [],
      regionCity: [],
      regionArea: [],
      regionName: [],
      isReginLoading: false,
      tempCateName: "",
      tempCateId: "",
      panoramicVisible: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.$store.dispatch("getUserInfo"); //更新用戶的配置
    getCateTree().then((res) => {
      this.cateTree = res.data;
      if (this.cateTree.length > 0) {
        // 默認選擇第一個
        this.info.cate = this.cateTree[0].id;
        this.info.cate_name = this.cateTree[0].name;
      }
    });

    getIndustry().then((res) => {
      if (res.code === 1 && res.data.length) {
        this.IndustryList = res.data.map((item) => {
          return item.name;
        });
        this.IndustryOriginalData = res.data;
      }
    });

    this.getTagList();

    // this.getRegoinList({ regoin_id: 0 });
  },
  mounted() {},
  methods: {
    //點擊選擇分類
    onSelectCate(selectedKeys, info) {
      if (selectedKeys.length > 0) {
        this.tempCateName = info.node.dataRef.name;
        this.tempCateId = selectedKeys[0];
      }
    },
    // 確認分類選擇
    confirmCate() {
      this.info.cate = this.tempCateId;
      this.info.cate_name = this.tempCateName;
      this.tempCateName = "";
      this.tempCateId = "";
      this.isShowCatePicker = false;
    },
    updateRegin(newValue) {
      this.info.region_name = newValue.name;
      this.info.region = newValue.id;
      console.log("region===", newValue.name, newValue.id);
    },
    getTagList() {
      getTag({ type: 0, filter: "all" }).then((res) => {
        if (res.code === 1 && res.data.length) {
          res.data.forEach((item) => {
            item.isSelected = false;
          });
          if (!this.tagList.length) {
            this.tagList = res.data;
          } else {
            let newTag = {};
            res.data.forEach((item) => {
              if (!this.tagList.some((value) => value.id === item.id)) {
                item.isSelected = true;
                newTag = item;
              }
            });
            this.tagList.push(newTag);
          }
        }
      });
    },
    back() {
      this.$router.back();
    },
    selectTag(id) {
      this.tagList.forEach((item) => {
        item.isSelected = item.id === id ? !item.isSelected : item.isSelected;
      });
    },
    showCatePicker() {
      this.isShowCatePicker = true;
    },
    onChangeCate(picker, values) {
      picker.setColumnValues(1, this.cateOriginalData[values[0]]);
    },
    confirmIndustry(value, index) {
      this.IndustryOriginalData.find((item) => {
        if (item.name === value) {
          this.info.industry = item.id;
          this.info.industry_name = item.name;
        }
      });
      this.isShowIndustryPicker = false;
    },
    confirmAddTag() {
      if (this.tagForm.name) {
        addTag(this.tagForm)
          .then((res) => {
            if (res.code === 1) {
              this.getTagList();
              this.$message.success(this.$t("publish.addNewTag.message"), 3);
            }
          })
          .catch((err) => {});
      }
    },
    tagModelclosed() {
      this.tagForm = { type: 0, name: "" };
    },
    addImage() {
      this.materialVisible = true;
    },
    deleteTag(item, event) {
      event.preventDefault();
      const { id } = item;
      const key = "tag-delete-key";
      this.$message.loading({
        content: this.$t("message.deleteLoading") + "...",
        key,
      });
      deleteTag({ id })
        .then((res) => {
          this.$message.success({
            content: this.$t("message.deleteSuccess"),
            key,
            duration: 1,
          });
          //本地刪除
          const index = this.tagList.findIndex((item) => item.id === id);
          if (index > 0) {
            this.$delete(this.tagList, index);
          }
        })
        .catch((err) => {
          this.$message.error({
            content: this.$t("message.deleteFail"),
            key,
            duration: 1,
          });
        });
    },
    confirm() {
      if (this.selectedKeys.length <= 0) {
        this.$message.warning(this.$t("message.selectPath"));
        return;
      }
      this.info.dir_id = this.selectedKeys[0];
      this.info.dir_name = this.selectedName;
      this.treeVisible = false;
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
      this.selectedName = info.node.dataRef.name;
    },
    onLoadData(treeNode) {
      return new Promise((resolve, reject) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
          if (res.code && res.data.length > 0) {
            treeNode.dataRef.children = res.data;
          } else {
            treeNode.dataRef.isLeaf = true;
          }
          this.treeData = [...this.treeData];
          resolve();
        });
      });
    },
    // 老的文件上傳完畢後的處理方法
    handlefileList(list) {
      let l_imgs = [];
      let m_imgs = []; //pano_id
      let panoVideos = [];
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          if (item.thumb_path) {
            m_imgs.push({
              imgsrc: item.location,
              imgname: item.filename,
              pano_id: item.id,
              thumb_path: item.thumb_path,
            });
          } else if (item.cover) {
            //全景視頻
            panoVideos.push({
              id: item.id,
              name: item.name,
              cover: item.cover,
            });
          } else {
            l_imgs.push({
              imgsrc: item.key,
              imgname: item.name,
              filesize: item.filesize,
            });
          }
        }
      }
      this.info.imgs = l_imgs;
      this.info.mimgs = m_imgs;
      this.info.panoVideos = panoVideos;
    },
    materialConfirm(list) {
      let materialList = list.map((item) => {
        //區分全景圖片還是全景視頻
        if (this.materialVisible) {
          item.bgImg = item.thumb_path;
          item.name = item.filename;
        } else {
          item.bgImg = item.cover;
          item.name = item.name;
        }
        return item;
      });
      let selectedList = [];
      if (this.$refs["uploader"].fileList.length) {
        materialList.forEach((item) => {
          if (
            !this.$refs["uploader"].fileList.some(
              (value) => value.id === item.id
            )
          ) {
            selectedList.push(item);
          }
        });
      } else {
        selectedList = materialList;
      }
      this.materialVisible
        ? (this.materialVisible = false)
        : (this.panoramicVisible = false);
      this.$refs["uploader"].fileList = [
        ...this.$refs["uploader"].fileList,
        ...selectedList,
      ];
      this.$refs["uploader"].returnFileList();
    },
    // 開始上傳圖片
    startUploadImage() {
      this.isUploading = true;
    },
    // 上傳失敗
    uploadFail() {
      this.isUploading = false;
    },
    updateImageList(fileList) {
      this.filesList = fileList;
      this.isUploading = false;
    },
    publish() {
      this.tagList.forEach((item) => {
        if (item.isSelected) {
          this.info.pic_tags.push(item.id);
        }
      });
      this.handlefileList(this.filesList);
      if (!this.info.imgs.length  && !this.info.mimgs.length && !this.info.panoVideos.length) {
        this.$message.error(this.$t("publish.publishNoSelectedMessage"));
        return;
      }
      if (this.info.name === "") {
        this.$message.error(this.$t("publish.workName.message"));
        return;
      }
      if (!this.info.industry) {
        this.$message.error(this.$t("publish.industry.message"));
        return;
      }
      if (!this.info.cate) {
        this.$message.error(this.$t("publish.workCategory.message"));
        return;
      }
      if (!this.info.region) {
        this.$message.error(this.$t("publish.workRegion.message"));
        return;
      }
      if (this.info.pic_tags.length === 0) {
        this.$message.error(this.$t("publish.workTag.message"));
        return;
      }
      if (this.info.customer_name === "") {
        this.$message.error(this.$t("publish.customerName.message"));
        return;
      }
      if (this.info.customer_phone === "") {
        this.$message.error(this.$t("publish.customerTel.message"));
        return;
      }
      if (this.info.detail_address === "") {
        this.$message.error(this.$t("publish.address.message"));
        return;
      }
      if (this.info.dir_id === "") {
        this.$message.error(this.$t("publish.savePath.message"));
        return;
      }

      let isError = false;
      if (!this.info.mimgs.length && this.info.panoVideos.length) {
        publishVRImg(this.info)
          .then((res) => {
            this.$router.push({ name: "mbWorkList" });
          })
          .catch((err) => {
            isError = true;
          });
      } else {
        publishVRImg(this.info)
          .then((res) => {
            this.$router.push({ name: "mbWorkList" });
          })
          .catch((err) => {
            isError = true;
          });
        setTimeout(() => {
          if (isError) return;
          this.$message.success({
            content: this.$t("publish.publishSuccess"),
            key: this.loadingKey,
            duration: 2,
          });
          this.$router.push({ name: "mbWorkList" });
        }, 1500);
      }
    },

    addPanoramic() {
      this.panoramicVisible = true;
    },
  },
};
</script>

<style  lang="less" scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.drag-upload {
  /*margin-top: 24px;*/
  width: 100%;
  background-color: rgba(0, 0, 0, 0.02);
}
.mb-publish-block {
  width: 100vw;
  min-height: 100vh;
  background: #fff;

  .publish-nav {
    width: 100vw;
    padding: 0 5vw;
    height: 50px;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mb-publish-panorama {
    /*margin-top: 52px;*/
    padding: 55px 5vw 0 5vw;
  }
  .info-tag-block {
    // padding: 5px 0 15px;
    padding: 5px 5vw 0 5vw;
    border-bottom: 1px solid #d7d7d7;
    .info-tag-title {
      width: 25%;
    }
    .info-tag-list {
      display: flex;
      flex-wrap: wrap;
      .tag-btns {
        border-radius: 50px;
        margin-bottom: 8px;
        line-height: 28px;
        padding: 0 10px;
      }
    }
  }
  .publich-btn {
    margin: 15px 0;
    padding: 0 5vw 10px 5vw;
    .btns {
      height: 38px;
    }
  }
  // .van-cell {
  //   padding: 10px 0;
  // }
  // .van-cell::after{
  //   left: 0;
  //   right: 0;
  // }
  .van-radio-group--horizontal {
    justify-content: flex-end !important;
  }
  .van-picker__columns {
    height: 35vh;
  }
  /deep/ .ant-input {
    border: none;
    text-align: right;
  }
  /deep/ .ant-cascader-input.ant-input {
    padding-right: 30px;
  }
  /deep/ .ant-cascader-picker-label {
    padding-right: 30px !important;
  }
  /deep/ .drag-upload .moxie-shim {
    height: 100% !important;
  }
}

.publish-success-box {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  .box-content {
    display: flex;
    flex-wrap: wrap;
    width: 200px;
    justify-content: center;
    h1 {
      width: 100%;
      font-size: 20px;
      color: #333;
      text-align: center;
      margin: 15px 0;
    }
    .edit-btn,
    .publish-btn {
      width: 100%;
      font-size: 14px;
      height: 34px;
    }
  }
  .mb-publish-info {
    padding-bottom: 20px;
  }
}
</style>
